export default __webpack_public_path__ + "static/media/angela.f11c20e0.png";